export default __webpack_public_path__ + "static/carousell-os-car-valuation-icon-transact-when-price-is-right-56cfd50981a594517374e16c391a8958.svg";